module.exports = __webpack_public_path__ + "img/USDCE.0dbb1031.png";